<button
  mat-mini-fab
  style="margin-bottom: 5px"
  (click)="refresh()"
  color="primary"
>
  <mat-icon>refresh</mat-icon>
</button>
<div>
  <div style="display: block; width: 350px; height: 188px">
    <canvas
      baseChart
      [data]="pie.data"
      type="pie"
      [options]="pie.options"
      (chartClick)="pie.chartClicked($event)"
    >
    </canvas>
  </div>
</div>
<h4 *ngIf="currentStatFilter">
  {{ currentStatFilter.name }} - {{ currentStatFilter.value }}
</h4>
<a *ngIf="currentStatFilter" (click)="clearFilter()">{{
  settings.lang.showAll
}}</a>
<h4 *ngIf="!currentStatFilter">
  {{ settings.lang.all }} - {{ helpers.length }}
</h4>
<div style="width: 100%; display: flex; justify-content: space-between">
  <mat-form-field class="full-width">
    <input
      matInput
      [(ngModel)]="searchString"
      placeholder="{{ settings.lang.searchVolunteer }}"
      [ngModelOptions]="{ standalone: true }"
    />
    <mat-icon matSuffix (click)="searchString = ''">clear</mat-icon>
  </mat-form-field>
  <mat-menu #appMenu="matMenu">
    <button mat-menu-item (click)="sendSmsToAll()">
      {{ settings.lang.sendSmsToAllVolunteersThatDidntGetOne }}
    </button>
    <button mat-menu-item (click)="sendAttendanceReminderSms()" *ngIf="admin()">
      {{ settings.lang.sendAttendanceReminder }}
    </button>
  </mat-menu>

  <button mat-icon-button [matMenuTriggerFor]="appMenu">
    <mat-icon>more_vert</mat-icon>
  </button>
</div>
<mat-card>
  <mat-nav-list>
    <ng-container *ngFor="let c of helpers">
      <mat-list-item
        class="followup-list-item"
        (click)="deliveryDetails(c)"
        *ngIf="showHelper(c)"
      >
        <div matLine style="display: flex; justify-content: space-between;">
          <div style="font-weight: 500;">
            <a>{{ c.name }}
              <span *ngIf="c.eventComment">, {{ c.eventComment }}</span>
            </a>
          </div>
          <div>
            <span *ngIf="c.viewedSms && c.smsWasSent">{{ settings.lang.smsSent }} {{ c.smsDateName }}</span>
            <span *ngIf="!c.viewedSms && c.smsWasSent">{{ settings.lang.smsNotOpened }}</span>
            <span *ngIf="!c.smsWasSent">{{ settings.lang.smsNotSent }}</span>
          </div>
        </div>
        <div matLine  style="font-size: 0.8em;">
          {{ settings.lang.completed }} {{ c.deliveries - c.inProgress }}/{{ c.deliveries }}
          <span *ngIf="c.problem > 0">&nbsp; ({{ c.problem }} {{ settings.lang.notDelivered }})</span>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-nav-list>
</mat-card>
